module.exports={
	"Form": "FundingCategoryCreateManifest",
	"Scope": "FundingCategory-Create",
	"Descriptors":
	{
		"FundingCategoryDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingCategory-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "FundingCategory-Create-Identity",
				"Group": "FundingCategory-Create-Identity"
			}
		},
		"FundingCategoryDetails.Code":
		{
			"Name": "Code",
			"Hash": "FundingCategory-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "FundingCategory-Create-Identity",
				"Group": "FundingCategory-Create-Identity"
			}
		},
		"FundingCategoryDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingCategory-Create-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Select2",
				"Row": "2",
				"Width": 4,
				"Section": "FundingCategory-Create-Details",
				"Group": "FundingCategory-Create-Details",
				"AllowCustomValues": false,
				"SelectOptions":
				[
					{
						"id": "Participating",
						"text": "Participating"
					},
					{
						"id": "Non-Participating",
						"text": "Non-Participating"
					},
					{
						"id": "Both",
						"text": "Both"
					}
				]
			}
		},
		"FundingCategoryDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingCategory-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "FundingCategory-Create-Details",
				"Group": "FundingCategory-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingCategory-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingCategory-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingCategory-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingCategory-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
